import React from 'react';
// import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { Trash2, Plus, Package, Calculator, MapPin, Weight, Shield } from 'lucide-react';
import { useMyContext } from '../../../../context/MyContext';
import axios from 'axios';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, getB2bpIncode, b2bPriceEstimator } from '../../../../config/config';
import { toast } from 'react-toastify';
import B2BViewRateForward from '../../../../component/b2b/models/priceEstimatorModelB2b';

const B2bRateCalculator = () => {
    
    const { isDarkMode, isToggleSidebar,selectedCft } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [formData, setFormData] = useState({
        originPincode: '',
        destinationPincode: '',
        insurance: 'Owner',
        totalWeight: '',
        cod_amount: '',
        totalBoxes: '',
        invoiceValue: '',
        paymentMode: '',
        pickupStatus: ''
    });

    const [boxes, setBoxes] = useState([]);
    const [originCity, setOriginCity] = useState('');
    const [destinationCity, setDestinationCity] = useState('');
    const [loading, setLoading] = useState(false);
    const [estimateData, setEstimateData] = useState([]);
    const [originODA, setOriginODA] = useState(null);
    const [destinationODA, setDestinationODA] = useState(null);

    const handleViewClick = () => {
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };


    // API function to fetch pincode data
    const fetchPincodeData = async (pincode, type) => {
        const token = localStorage.getItem("token");
        const cus_id = localStorage.getItem("cus_id");
        const urlgetPincode = `${Base_Url}${getB2bpIncode}?pincode=${pincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: "GET",
                headers: {
                    token: token,
                    cus_id: cus_id,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS" && data.data) {
                // API returns object now
                let { city, state, oda } = data.data;

                // Capitalize
                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

                // Set city for origin or destination
                if (type === "origin") {
                    setOriginCity(city);
                    setOriginODA(oda);   // <--- NEW
                } else if (type === "destination") {
                    setDestinationCity(city);
                    setDestinationODA(oda);  // <--- NEW
                }
                return { city, state, oda, success: true };
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                toast.error(data.message + " Please login Again");
                return { success: false, error: "unauthorized" };
            }
            else {
                toast.error("Failed to fetch pincode details");
                return { success: false, error: "failed" };
            }
        } catch (error) {
            console.error("Error fetching pincode data:", error);
            toast.error("Error fetching pincode data");
            return { success: false, error: "network" };
        }
    };

    const handleInputChange = async (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Origin pincode
        if (field === 'originPincode') {

            // reset origin & destination ODA when typing
            setOriginODA(null);

            if (value.length === 6) {
                setLoading(true);
                await fetchPincodeData(value, 'origin');
                setLoading(false);
            } else {
                setOriginCity('');
            }
        }

        // Destination pincode
        if (field === 'destinationPincode') {

            // reset destination ODA when typing
            setDestinationODA(null);

            if (value.length === 6) {
                setLoading(true);
                await fetchPincodeData(value, 'destination');
                setLoading(false);
            } else {
                setDestinationCity('');
            }
        }
    };

    const addBoxSet = () => {
        const totalBoxesUsed = boxes.reduce((sum, box) => sum + parseInt(box.quantity || 0), 0);
        const remainingBoxes = parseInt(formData.totalBoxes || 0) - totalBoxesUsed;

        if (remainingBoxes > 0) {
            setBoxes(prev => [...prev, {
                id: Date.now(),
                quantity: '',
                length: '',
                width: '',
                height: ''
            }]);
        }
    };

    const removeBoxSet = (id) => {
        setBoxes(prev => prev.filter(box => box.id !== id));
    };

    // const updateBoxSet = (id, field, value) => {
    //     setBoxes(prev => prev.map(box =>
    //         box.id === id ? { ...box, [field]: value } : box
    //     ));
    // };

    const updateBoxSet = (id, field, value) => {
        setBoxes(prev => prev.map(box => {
            if (box.id === id) {
                if (field === 'quantity') {
                    const newQuantity = parseInt(value || 0);
                    const totalBoxes = parseInt(formData.totalBoxes || 0);

                    const otherBoxesUsed = prev
                        .filter(b => b.id !== id)
                        .reduce((sum, b) => sum + parseInt(b.quantity || 0), 0);

                    const maxAllowed = totalBoxes - otherBoxesUsed;

                    // Automatically cap the value to the maximum allowed
                    const cappedQuantity = Math.min(newQuantity, maxAllowed);
                    return { ...box, [field]: cappedQuantity.toString() };
                }

                return { ...box, [field]: value };
            }
            return box;
        }));
    };

    const getTotalBoxesUsed = () => {
        return boxes.reduce((sum, box) => sum + parseInt(box.quantity || 0), 0);
    };

    const getRemainingBoxes = () => {
        return parseInt(formData.totalBoxes || 0) - getTotalBoxesUsed();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        for (const box of boxes) {
            if (
                !box.length ||
                !box.width ||
                !box.height ||
                box.length === "" ||
                box.width === "" ||
                box.height === ""
            ) {
                toast.error("Please enter Length, Width, and Height for all boxes.");
                return; // stop execution
            }
        }
        const payload = {
            retailer_id: parseInt(localStorage.getItem("cus_id")),
            origin_pincode: formData.originPincode,
            destination_pincode: formData.destinationPincode,
            insorance: formData.insurance,
            weight: parseFloat(formData.totalWeight),
            payment_Mode: formData.paymentMode,
            pickup_status: formData.pickupStatus,
            cfr : selectedCft,
            invoice_value: parseFloat(formData.invoiceValue || 0),
            dimensions: boxes.map((box) => ({
                quantity: parseInt(box.quantity),
                total_length: parseFloat(box.length),
                total_width: parseFloat(box.width),
                total_height: parseFloat(box.height),
            })),
        };

        try {
            const token = localStorage.getItem("token");
            const cus_id = localStorage.getItem("cus_id");
            const response = await axios.post(
                Base_Url + b2bPriceEstimator, // 👈 API endpoint
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token, // 👈 if API expects Bearer token
                        cus_id: cus_id, // 👈 custom header for customer id
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message);
                setEstimateData(response.data);
                handleViewClick();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching rates");
            if (error.response?.data?.messages) {
                const messages = error.response.data.messages;

                // Show each error message as a toast
                Object.values(messages).forEach((msg) => {
                    toast.error(msg);
                });
            } else if (error.response?.data?.message) {
                // Fallback to single error message
                toast.error(error.response.data.message);
            } else {
                // Generic error fallback
                toast.error("Something went wrong while fetching rates");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>

            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                <div className="w-full mx-auto custom-scrollbar mt-5">
                    <div className="grid lg:grid-cols-3 gap-1">
                        {/* Main Form */}
                        <div className="lg:col-span-2">
                            <div className={`${isDarkMode ? 'bg-customPurple' : 'bg-white border-gray-200'} rounded-lg shadow-lg border p-4`}>
                                <form onSubmit={handleSubmit} className="space-y-4">
                                    {/* Pincode Section */}
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-1 mb-1">
                                            <MapPin className={`w-4 h-4 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                                            <h2 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                Pickup & Delivery Details
                                            </h2>
                                        </div>
                                        <div className="grid md:grid-cols-2 gap-3">
                                            <div className="space-y-1">
                                                <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                    Origin Pincode *
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength="6"
                                                    value={formData.originPincode}
                                                    onChange={(e) => handleInputChange('originPincode', e.target.value.replace(/[^0-9]/g, ''))}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? 'bg-slate-700 border-slate-600 text-white focus:border-blue-400'
                                                        : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-blue-500'
                                                        } focus:outline-none focus:ring-2 focus:ring-blue-500/20`}
                                                    placeholder="Enter 6-digit pincode"
                                                    disabled={loading}
                                                />
                                                {loading && formData.originPincode.length === 6 && (
                                                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        🔄 Fetching city...
                                                    </p>
                                                )}
                                                {originCity && (
                                                    <p className={`text-xs ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                                        📍 {originCity}
                                                    </p>
                                                )}
                                                {originODA == 1 && (
                                                    <p className="text-xs text-red-500">
                                                        ⚠️ This pincode is ODA
                                                    </p>
                                                )}
                                            </div>

                                            <div className="space-y-1">
                                                <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                    Destination Pincode *
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength="6"
                                                    value={formData.destinationPincode}
                                                    onChange={(e) => handleInputChange('destinationPincode', e.target.value.replace(/[^0-9]/g, ''))}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? 'bg-slate-700 border-slate-600 text-white focus:border-blue-400'
                                                        : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-blue-500'
                                                        } focus:outline-none focus:ring-2 focus:ring-blue-500/20`}
                                                    placeholder="Enter 6-digit pincode"
                                                    disabled={loading}
                                                />
                                                {loading && formData.destinationPincode.length === 6 && (
                                                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        🔄 Fetching city...
                                                    </p>
                                                )}
                                                {destinationCity && (
                                                    <p className={`text-xs ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                                        📍 {destinationCity}
                                                    </p>
                                                )}
                                                {destinationODA == 1 && (
                                                    <p className="text-xs text-red-500">
                                                        ⚠️ This pincode is ODA
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* Insurance Section */}
                                    <div className="space-y-1">
                                        <div className="flex items-center space-x-1">
                                            <Shield className={`w-4 h-4 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />
                                            <h2 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                Insurance Options
                                            </h2>
                                        </div>

                                        <div className="grid md:grid-cols-2 gap-2">
                                            <label className={`relative flex items-center p-2 rounded-lg border cursor-pointer transition-all duration-300 ${formData.insurance === 'Owner'
                                                ? isDarkMode ? 'border-blue-400 bg-blue-900/20' : 'border-blue-500 bg-blue-50'
                                                : isDarkMode ? 'border-slate-600 bg-slate-700' : 'border-gray-300 bg-gray-50'
                                                }`}>
                                                <input
                                                    type="radio"
                                                    name="insurance"
                                                    value="Owner"
                                                    checked={formData.insurance === 'Owner'}
                                                    onChange={(e) => handleInputChange('insurance', e.target.value)}
                                                    className="sr-only"
                                                />
                                                <div className={`w-3 h-3 rounded-full border mr-2 flex items-center justify-center ${formData.insurance === 'Owner'
                                                    ? 'border-blue-500'
                                                    : isDarkMode ? 'border-slate-400' : 'border-gray-400'
                                                    }`}>
                                                    {formData.insurance === 'Owner' && (
                                                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                                    )}
                                                </div>
                                                <div>
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                        Owner Risk
                                                    </span>
                                                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Customer bears the risk
                                                    </p>
                                                </div>
                                            </label>

                                            <label className={`relative flex items-center p-2 rounded-lg border cursor-pointer transition-all duration-300 ${formData.insurance === 'Carrier'
                                                ? isDarkMode ? 'border-blue-400 bg-blue-900/20' : 'border-blue-500 bg-blue-50'
                                                : isDarkMode ? 'border-slate-600 bg-slate-700' : 'border-gray-300 bg-gray-50'
                                                }`}>
                                                <input
                                                    type="radio"
                                                    name="insurance"
                                                    value="Carrier"
                                                    checked={formData.insurance === 'Carrier'}
                                                    onChange={(e) => handleInputChange('insurance', e.target.value)}
                                                    className="sr-only"
                                                />
                                                <div className={`w-3 h-3 rounded-full border mr-2 flex items-center justify-center ${formData.insurance === 'Carrier'
                                                    ? 'border-blue-500'
                                                    : isDarkMode ? 'border-slate-400' : 'border-gray-400'
                                                    }`}>
                                                    {formData.insurance === 'Carrier' && (
                                                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                                    )}
                                                </div>
                                                <div>
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                        Carrier Risk
                                                    </span>
                                                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Carrier bears the risk
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Weight and Boxes Section */}
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-1">
                                            <Weight className={`w-4 h-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                                            <h2 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                Weight & Package Details
                                            </h2>
                                        </div>

                                        <div className="grid md:grid-cols-3 gap-3">
                                            <div className="space-y-1">
                                                <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                    Total Weight (kg) *
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    value={formData.totalWeight}
                                                    onChange={(e) => handleInputChange('totalWeight', e.target.value)}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? 'bg-slate-700 border-slate-600 text-white focus:border-purple-400'
                                                        : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500'
                                                        } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                    placeholder="Enter total weight"
                                                />
                                            </div>

                                            <div className="space-y-1">
                                                <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                    Total Boxes *
                                                </label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={formData.totalBoxes}
                                                    onChange={(e) => handleInputChange('totalBoxes', e.target.value)}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? 'bg-slate-700 border-slate-600 text-white focus:border-purple-400'
                                                        : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500'
                                                        } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                    placeholder="Number of boxes"
                                                />
                                            </div>

                                            <div className="space-y-1">
                                                <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                    Invoice Value
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    value={formData.invoiceValue}
                                                    onChange={(e) => handleInputChange('invoiceValue', e.target.value)}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? 'bg-slate-700 border-slate-600 text-white focus:border-purple-400'
                                                        : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500'
                                                        } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                    placeholder="Declared value"
                                                />
                                            </div>
                                            <div className="space-y-1">
                                                <label
                                                    className={`block text-xs font-medium ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                        }`}
                                                >
                                                    Payment Mode
                                                </label>

                                                <select
                                                    value={formData.paymentMode}
                                                    onChange={(e) => handleInputChange("paymentMode", e.target.value)}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? "bg-slate-700 border-slate-600 text-white focus:border-purple-400"
                                                        : "bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500"
                                                        } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                >
                                                    <option value="">Select Payment Mode</option>
                                                    <option value="prepaid">Prepaid</option>
                                                    <option value="cod">COD</option>
                                                </select>
                                            </div>

                                            {
                                                formData.paymentMode === 'cod' ?
                                                    <div className="space-y-1">
                                                        <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                            Cod Amount *
                                                        </label>
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={formData.cod_amount}
                                                            onChange={(e) => handleInputChange('cod_amount', e.target.value)}
                                                            className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                                ? 'bg-slate-700 border-slate-600 text-white focus:border-purple-400'
                                                                : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500'
                                                                } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                            placeholder="Cod Amount"
                                                        />
                                                    </div>
                                                    : ""
                                            }



                                            <div className="space-y-1">
                                                <label
                                                    className={`block text-xs font-medium ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                        }`}
                                                >
                                                    How would you like to arrange the pickup ?
                                                </label>

                                                <select
                                                    value={formData.pickupStatus}
                                                    onChange={(e) => handleInputChange("pickupStatus", e.target.value)}
                                                    className={`w-full px-2 py-1.5 text-xs rounded-lg border transition-all duration-300 ${isDarkMode
                                                        ? "bg-slate-700 border-slate-600 text-white focus:border-purple-400"
                                                        : "bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500"
                                                        } focus:outline-none focus:ring-2 focus:ring-purple-500/20`}
                                                >
                                                    <option value="">Select Pickup </option>
                                                    <option value="fmpickup">Yes,FM Pickup</option>
                                                    <option value="selfdrop">I will Self Drop</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Box Sets Section */}
                                    <div className="space-y-3">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center space-x-1">
                                                <Package className={`w-4 h-4 ${isDarkMode ? 'text-orange-400' : 'text-orange-600'}`} />
                                                <h2 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                    Box Dimensions
                                                </h2>
                                            </div>

                                            {formData.totalBoxes && getRemainingBoxes() > 0 && (
                                                <button
                                                    type="button"
                                                    onClick={addBoxSet}
                                                    className="flex items-center space-x-1 px-2 py-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105"
                                                >
                                                    <Plus className="w-3 h-3" />
                                                    <span>Add Box Set</span>
                                                </button>
                                            )}
                                        </div>

                                        {formData.totalBoxes && (
                                            <div className={`p-2 rounded-lg ${isDarkMode ? 'bg-slate-700/50' : 'bg-blue-50'} border ${isDarkMode ? 'border-slate-600' : 'border-blue-300'}`}>
                                                <div className="flex justify-between items-center">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                        Total Boxes: {formData.totalBoxes}
                                                    </span>
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                        Used: {getTotalBoxesUsed()} | Remaining: {getRemainingBoxes()}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Box Sets */}
                                        <div className="space-y-2">
                                            {boxes.map((box, index) => (
                                                <div key={box.id} className={`p-3 rounded-lg border transition-all duration-300 ${isDarkMode
                                                    ? 'bg-slate-700 border-slate-600 hover:border-slate-500'
                                                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                                                    }`}>
                                                    <div className="flex items-center justify-between mb-2">
                                                        <h3 className={`text-xs font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                            Box Set {index + 1}
                                                        </h3>
                                                        <button
                                                            type="button"
                                                            onClick={() => removeBoxSet(box.id)}
                                                            className="p-1 text-red-500 hover:bg-red-500 hover:text-white rounded transition-all duration-300"
                                                        >
                                                            <Trash2 className="w-3 h-3" />
                                                        </button>
                                                    </div>

                                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                                                        <div className="space-y-1">
                                                            <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                Quantity *
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                max={getRemainingBoxes() + parseInt(box.quantity || 0)}
                                                                value={box.quantity}
                                                                onChange={(e) => updateBoxSet(box.id, 'quantity', e.target.value)}
                                                                className={`w-full px-2 py-1 text-xs rounded border transition-all duration-300 ${isDarkMode
                                                                    ? 'bg-slate-600 border-slate-500 text-white'
                                                                    : 'bg-white border-gray-300 text-gray-900'
                                                                    } focus:outline-none focus:ring-1 focus:ring-blue-500/50`}
                                                                placeholder="Qty"
                                                            />
                                                        </div>

                                                        <div className="space-y-1">
                                                            <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                Length (cm) *
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                value={box.length}
                                                                onChange={(e) => updateBoxSet(box.id, 'length', e.target.value)}
                                                                className={`w-full px-2 py-1 text-xs rounded border transition-all duration-300 ${isDarkMode
                                                                    ? 'bg-slate-600 border-slate-500 text-white'
                                                                    : 'bg-white border-gray-300 text-gray-900'
                                                                    } focus:outline-none focus:ring-1 focus:ring-blue-500/50`}
                                                                placeholder="L"
                                                            />
                                                        </div>

                                                        <div className="space-y-1">
                                                            <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                Width (cm) *
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                value={box.width}
                                                                onChange={(e) => updateBoxSet(box.id, 'width', e.target.value)}
                                                                className={`w-full px-2 py-1 text-xs rounded border transition-all duration-300 ${isDarkMode
                                                                    ? 'bg-slate-600 border-slate-500 text-white'
                                                                    : 'bg-white border-gray-300 text-gray-900'
                                                                    } focus:outline-none focus:ring-1 focus:ring-blue-500/50`}
                                                                placeholder="W"
                                                            />
                                                        </div>

                                                        <div className="space-y-1">
                                                            <label className={`block text-xs font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                Height (cm) *
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                value={box.height}
                                                                onChange={(e) => updateBoxSet(box.id, 'height', e.target.value)}
                                                                className={`w-full px-2 py-1 text-xs rounded border transition-all duration-300 ${isDarkMode
                                                                    ? 'bg-slate-600 border-slate-500 text-white'
                                                                    : 'bg-white border-gray-300 text-gray-900'
                                                                    } focus:outline-none focus:ring-1 focus:ring-blue-500/50`}
                                                                placeholder="H"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="pt-3">
                                        <button
                                            type="submit"
                                            disabled={loading || !formData.originPincode || !formData.destinationPincode || !formData.totalWeight || !formData.totalBoxes || getTotalBoxesUsed() !== parseInt(formData.totalBoxes || 0)}
                                            className={`w-full py-2 px-4 rounded-lg text-xs font-semibold transition-all duration-300 transform hover:scale-105 ${loading || !formData.originPincode || !formData.destinationPincode || !formData.totalWeight || !formData.totalBoxes || getTotalBoxesUsed() !== parseInt(formData.totalBoxes || 0)
                                                ? 'bg-gray-400 cursor-not-allowed'
                                                : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-md hover:shadow-lg'
                                                } text-white`}
                                        >
                                            {loading ? (
                                                <div className="flex items-center justify-center space-x-2">
                                                    <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                    <span>Calculating...</span>
                                                </div>
                                            ) : (
                                                <div className="flex items-center justify-center space-x-2">
                                                    <Calculator className="w-3 h-3" />
                                                    <span>Calculate Rate</span>
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="space-y-3">
                            {/* Summary Card */}
                            <div className={`${isDarkMode ? 'bg-customPurple' : 'bg-white border-gray-200'} h-[250px] rounded-lg shadow-lg border p-3`}>
                                <h3 className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                    Shipment Summary
                                </h3>

                                <div className="space-y-4 mt-4">
                                    <div className="flex justify-between">
                                        <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Origin:</span>
                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                            {originCity || 'Not set'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Destination:</span>
                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                            {destinationCity || 'Not set'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Total Weight:</span>
                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                            {formData.totalWeight ? `${formData.totalWeight} kg` : 'Not set'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Total Boxes:</span>
                                        <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                            {formData.totalBoxes || 'Not set'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Insurance:</span>
                                        <span className={`text-xs font-medium capitalize ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                            {formData.insurance} Risk
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Box Details Card */}
                            {boxes.length > 0 && (
                                <div className={`${isDarkMode ? 'bg-customPurple' : 'bg-white border-gray-200'} rounded-lg shadow-lg border p-3`}>
                                    <h3 className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                        Box Details
                                    </h3>

                                    <div className="space-y-2">
                                        {boxes.map((box, index) => (
                                            <div key={box.id} className={`p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-gray-50'}`}>
                                                <div className="flex justify-between items-center mb-1">
                                                    <span className={`text-xs font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                        Set {index + 1}
                                                    </span>
                                                    <span className={`text-xs px-1 py-0.5 rounded ${isDarkMode ? 'bg-blue-900 text-blue-200' : 'bg-blue-100 text-blue-800'}`}>
                                                        {box.quantity || 0} boxes
                                                    </span>
                                                </div>
                                                <div className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                    {box.length || 0} × {box.width || 0} × {box.height || 0} cm
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Instructions Card */}
                            {boxes.length > 0 ? (
                                <div
                                    className={`${isDarkMode ? "bg-customPurple" : "bg-white border-gray-200"
                                        } rounded-lg shadow-lg border p-3 mt-8`}
                                    style={{ height: "240px" }}
                                >
                                    <h3
                                        className={`text-sm font-semibold mb-2 ${isDarkMode ? "text-white" : "text-gray-900"
                                            }`}
                                    >
                                        How to Use
                                    </h3>

                                    <div className="space-y-2 text-xs overflow-y-auto">
                                        <div
                                            className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                }`}
                                        >
                                            <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                                1
                                            </span>
                                            <span>Enter origin and destination pincodes</span>
                                        </div>
                                        <div
                                            className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                }`}
                                        >
                                            <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                                2
                                            </span>
                                            <span>Select insurance type and enter package details</span>
                                        </div>
                                        <div
                                            className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                }`}
                                        >
                                            <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                                3
                                            </span>
                                            <span>Add box sets with dimensions for each type</span>
                                        </div>
                                        <div
                                            className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                                }`}
                                        >
                                            <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                                4
                                            </span>
                                            <span>Click calculate to get your shipping rate</span>
                                        </div>
                                    </div>
                                </div>
                            ) : (<div
                                className={`${isDarkMode ? "bg-customPurple" : "bg-white border-gray-200"
                                    } rounded-lg shadow-lg border p-3 mt-4`}
                            >
                                <h3
                                    className={`text-sm font-semibold mb-2 ${isDarkMode ? "text-white" : "text-gray-900"
                                        }`}
                                >
                                    How to Use
                                </h3>

                                <div className="space-y-2 text-xs overflow-y-auto">
                                    <div
                                        className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                            }`}
                                    >
                                        <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                            1
                                        </span>
                                        <span>Enter origin and destination pincodes</span>
                                    </div>
                                    <div
                                        className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                            }`}
                                    >
                                        <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                            2
                                        </span>
                                        <span>Select insurance type and enter package details</span>
                                    </div>
                                    <div
                                        className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                            }`}
                                    >
                                        <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                            3
                                        </span>
                                        <span>Add box sets with dimensions for each type</span>
                                    </div>
                                    <div
                                        className={`flex items-start space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-700"
                                            }`}
                                    >
                                        <span className="flex-shrink-0 w-3 h-3 bg-blue-500 text-white text-xs rounded-full flex items-center justify-center mt-0.5">
                                            4
                                        </span>
                                        <span>Click calculate to get your shipping rate</span>
                                    </div>
                                </div>
                            </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
            <B2BViewRateForward
                isopen={isPopupOpen}
                onClose={handleClose}
                data={estimateData}
                type="checkRates"
            />
        </div>
    );
};

export default B2bRateCalculator;